export default __webpack_public_path__ + "static/media/gym_access.38efc98a.svg";